import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
export const MuiSelect = {
    defaultProps: {
        IconComponent: ExpandMoreRoundedIcon
    },
    styleOverrides: {
        icon: {
            transition: "transform 0.3s ease"
        }
    }
};
//# sourceMappingURL=Select.js.map